import { ActionReducer, MetaReducer, ActionReducerMap, combineReducers } from '@ngrx/store';
import * as auth from '../authentication/state/reducers/authentication.reducers';
import * as user from '../users/state/reducers/user.reducers';
import * as organization from '../suppliers/state/reducers/organization.reducers';

import * as requestList from '../requests/state/reducers/request/request.reducers';
import * as requestForm from '../requests/state/reducers/request-form/request-form.reducers';
import * as supplierList from '../requests/state/reducers/supplier-list/supplier-list.reducers';
import * as verificationCache from '../requests/state/reducers/verification-cache/verification-cache.reducers';

import { localStorageSync } from 'ngrx-store-localstorage';

import { AuthenticationEffects } from '../authentication/state/effects/authentication.effects';
import { UserEffects } from '../users/state/effects/user.effects';
import { OrganizationEffects } from '../suppliers/state/effects/organization.effects';
import { RequestEffects } from '../requests/state/effects/request/request.effects';
import { RequestFormEffects } from '../requests/state/effects/request-form/request-form.effects';
import { SupplierListEffects } from '../requests/state/effects/supplier-list/supplier-list.effects';
import { VerificationCacheEffects } from '../requests/state/effects/verification-cache/verification-cache.effects';

import { REQUESTS_FEATURE_KEY, RequestsFeatureState } from '../requests/state/selector';
export interface State {
  auth: auth.AuthState;
  user: user.UserState;
  organization: organization.OrganizationState;

  [REQUESTS_FEATURE_KEY]: RequestsFeatureState;
}

const requestsFeatureReducer = combineReducers<RequestsFeatureState>({
  list: requestList.reducer,
  form: requestForm.reducer,
  supplierList: supplierList.reducer,
  verificationCache: verificationCache.reducer,
});

export const reducers: ActionReducerMap<State> = {
  auth: auth.reducer,
  user: user.reducer,
  organization: organization.reducer,

  [REQUESTS_FEATURE_KEY]: requestsFeatureReducer,
};

export const effects = [
  AuthenticationEffects,
  UserEffects,
  OrganizationEffects,
  RequestEffects,
  RequestFormEffects,
  SupplierListEffects,
  VerificationCacheEffects,
];

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['auth'], rehydrate: true })(reducer);
}

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];
